<template>
  <div>
    <div class="group_1" v-if="showBtn" @click="handleInvited">
      <div class="close" @click.stop="showBtn=false">
        <img src="@/assets/images/close.svg" alt="">
      </div>
      <img src="@/assets/images/Group 1366@2x.png" alt="" style="width: 140px; height: 250px" />
    </div>
      <!-- 邀请新人弹框 -->
    <el-dialog title="平台邀请新用户，积分奖励拿到手软！"
               :visible.sync="dialogVisible"
               class="newUserbox">
      <div class="newsUsertext">
        <div class="userTitle">邀请好友加入平台，轻松赚积分，可兑换好礼、抵扣课程费用，福利多多！以下是详细规则：</div>
        <div><img src="@/assets/images/image 37@2x.png"
               alt=""
               class="newIcon"></div>
        <div>
          <div class="mtp12">
            <span style="font-weight: 600;">一、参与条件​</span><br />

            所有平台注册用户均可参与，分享平台链接邀请好友，开启积分赚取之旅。<br />
          </div>

          <div class="mtp12">
            <span style="font-weight: 600">二、新用户判定</span> ​<br />

            系统精准判定：新用户指从未在本平台注册过的用户。若好友已注册，邀请人无法获得积分。<br />
          </div>
          <div class="mtp12">
            <span style="font-weight: 600"> 三、邀请步骤</span> ​<br />
            <div class="liucheng">
              <span>点击底部按钮获取链接</span>
              <img src="@/assets/images/Group 1169@2x.png"
                   alt="">
              <span>分享链接给好友</span>
              <img src="@/assets/images/Group 1169@2x.png"
                   alt="">

              <span>好友购买课程</span>
              <img src="@/assets/images/Group 1169@2x.png"
                   alt="">

              <span>您获取积分</span>

            </div>
            <!-- 点击底部“获取链接分享好友”按钮将链接分享给好友（微信、QQ、短信等均可）。​
            好友通过链接注册登录，即绑定为你的被邀请用户，好友在平台的每一笔消费你都可以获得积分。 -->
          </div>
          <div class="mtp12">
            <span style="font-weight: 600">四、积分获取规则​<br /></span>
            ​ 新用户购买产品并支付成功，邀请人获相应积分，​积分与好友消费金额等额，如好友消费 180 元，邀请人得 180 积分。​
            无时间限制，好友任何时候购买支付成功，邀请人均可获积分。​好友订单退款，邀请人对应积分将被扣除。 好友支付成功后，24
            小时内发放积分。特殊情况延迟到账，平台会发通知说明。
          </div>
          <div class="mtp12">
            <span style="font-weight: 600"> 五、积分价值、用法 <br></span>
            ​ 30 积分 = 1 元，积少成多可攒 “小财富”。​积分可在平台商城兑换精美商品兑换的商品不退不换。​
            购买课程时抵扣现金（具体规则按平台规定） 在平台 “学习中心 — 积分商城”
            查看积分明细（获取、使用、过期等）和查看商品列表
          </div>
          <div class="mtp12">
            <span style="font-weight: 600"> 六、其他说明​ <br></span>
            平台监控邀请行为，不正当手段（虚假注册、恶意下单等）获取积分者，将被取消资格，情节严重者追究法律责任。​
            本规则最终解释权归平台，调整修改会通过公告通知，请注意查看。 点击获取链接邀请新用户
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: center;">
        <div class="newsBtn"
             @click="inviteNewUsers">点击获取链接邀请新用户</div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getShareUrl } from '@/api/index';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},

  data() {
    // 这里存放数据
    return {
      showBtn:true,
      dialogVisible:false,
      shareUrl:'',


    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
        //邀请新人
    handleInvited() {
      this.dialogVisible = true;
    },
    //复制链接按钮
    inviteNewUsers() {
      getShareUrl().then(res => {
        if (res.data.code == 200) {
          this.shareUrl = res.data.msg;

          const textarea = document.createElement('textarea');
          if (this.shareUrl != null && this.shareUrl != '') {
            textarea.value = this.shareUrl;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
              document.execCommand('copy');
              this.$message({
                message: '链接复制成功 快去分享给好友吧!',
                type: 'success',
                duration: 1000
              });
              this.tip = '链接复制成功 快去分享给好友吧!';
              setTimeout(() => {
                this.tip = '';
              }, 2000);
            } catch (err) {
              this.$message({
                message: '复制失败！',
                duration: 800
              });
              console.error('复制失败:', err);
            }
            document.body.removeChild(textarea);
          } else {
            this.$message({
              message: '复制失败！',

              duration: 800
            });
          }
        }
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.group_1 {
  cursor: pointer;
  position: absolute;
  top: 97px;
  right: 97px;
  width: 140px; height: 250px;
  .close{
    position: absolute;
    top: 6px;
    right: 6px;
    img{
      width: 20px;
      height: 20px;
    }
  }
}
.newUserbox {
  ::v-deep {
    .el-dialog {
      width: 670px;
      // height: 561px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
    }
    .el-dialog__header {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
    }
    .el-dialog__body {
      padding-top: 12px !important;
    }
  }
}
.mtp12 {
  margin-top: 12px;
}
.liucheng {
  display: flex;
  margin-bottom: 13px;

  justify-content: space-between;
  align-items: center;
  margin-top: 7px;
  span {
    display: inline-block;
    padding: 8px 10px;
    height: 32px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #f70004;
    background: rgba(255, 51, 55, 0.1);
    border-radius: 4px 4px 4px 4px;
  }
  img {
    width: 18px;
    height: 18px;
  }
}
.newsUsertext {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  .userTitle {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    width: 630px;
    height: 40px;
    background-image: url('../../assets/images/Mask group@2x.png');
    background-size: cover;
    line-height: 40px;
    padding-left: 10px;
    position: relative;
  }
  .newIcon {
    position: absolute;
    top: 58px;
    right: 20px;
    width: 47px;
    height: 55px;
  }
}
.newsBtn {
  cursor: pointer;

  margin-top: 20px;
  width: 220px;
  height: 36px;
  background: #ff8833;
  box-shadow: 0px 4px 10px 0px rgba(255, 136, 51, 0.2);
  border-radius: 8px 8px 8px 8px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
}
</style>
